<template>
  <b-container class="paragraph-with-sidebar">
    <b-row class="item align-items-center">
      <b-col cols="8" class="text d-flex flex-column">
        <div v-for="item in slice.items" :key="item.id" :to="item.link.url" class="content-wrapper">
          <div v-if="item.label != null">
            <h3 class="text-break"><b>{{item.label}}</b></h3>
            <Swoosh class="smallSwoosh" :uid="item.uid" animate />
            <div class="rich-text-wrapper">
              <prismic-rich-text :field="item.bodyText" />
            </div>
          </div>
          <template v-if="item.link.url">
            <b-button
                variant="primary"
                class="outline text-truncate"
                :aria-label="item.link.label"
                :href="item.link.url"
            >
              {{item.link.label || 'Link'}}
            </b-button>
          </template>
          <template v-else-if="item.link.uid">
            <b-button
                variant="primary"
                class="outline text-truncate"
                :aria-label="item.link.label"
                :to="'/'+language+'/'+item.link.uid"
            >
              {{item.link.label || 'Link'}}
            </b-button>
          </template>
        </div>
      </b-col>
      <b-col cols="4" v-if="hasSidebarRight" class="d-flex justify-content-center sidebar-col">
        <div v-if="item.label != null" class="sidebar-content">
          <h3 class="text-break"><b>{{item.label}}</b></h3>
          <Swoosh class="smallSwoosh" animate />
        </div>
        <div class="rich-text-wrapper">
          <prismic-rich-text :field="slice.primary.optional_sidebar_right" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// import Swoosh from "@/components/ui/Swoosh.vue";
import Swoosh from "./Swoosh.vue";

export default {
  name: "SliceParagraphWithVisual",
  props:['item', 'slice'],
  components: {Swoosh},
  methods: {

  },
  computed: {
    hasSidebarRight(){
      const hasRight = (this.slice.primary.optional_sidebar_right);
      console.log(hasRight);
      return hasRight != undefined;
    },
  }
}
</script>

<style scoped lang="scss">
.paragraph-with-sidebar {
  overflow-x: hidden;
}

.item {
  .text, .sidebar-col {
    min-width: 0; // Critical for flex items to shrink properly
    overflow: hidden; // Prevent content from spilling out
  }
  .text {
    padding-right: 3rem;
  }
}

// Content wrapper to control overflow
.content-wrapper {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

// Text content overflow handling
.rich-text-wrapper {
  :deep(p), :deep(div), :deep(span) {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  :deep(img), :deep(video), :deep(iframe) {
    max-width: 100% !important;
    height: auto;
  }
  :deep(table) {
    table-layout: fixed;
    width: 100%;
  }
  :deep(pre), :deep(code) {
    white-space: pre-wrap;
    overflow-x: auto;
    max-width: 100%;
  }
}

.sidebar-col {
  .sidebar-content {
    width: 100%;
    max-width: 100%;
  }
}

.headline {
  .desktop & h1 {
    max-width: 80%;
  }

  .mobile & {
    h1 {
      line-height: 100%;
    }

    & .swoosh {
      width: 100%;
      max-width: 100%;
    }
  }

  .tablet & .swoosh {
    width: 70%;
    max-width: 100%;
  }

  .desktop & .swoosh {
    width: 50%;
    max-width: 100%;
  }
}

.items {
  .item {
    margin-bottom: 1rem;
    min-height: 0vw;

    .visual {
      aspect-ratio: 1/1;
      width: 100%;
      max-width: 100%;
      object-fit: cover;
      @include swoosh;
    }

    .text {
      text-align: start;
      padding: 1rem;
      margin-right: 2rem;
      min-width: 0; // Added for flex shrinking

      h3 {
        text-align: start;
        word-wrap: break-word; // Added
      }

      .outline {
        margin-top: 1rem;
        align-self: center;
        max-width: 100%; // Added
      }
    }
  }
}

.smallSwoosh {
  max-width: 60%;
  margin-bottom: 1rem;
  width: 33%;
}

.text-break {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

.text-truncate {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

</style>